import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { reorderLocation } from '../Api'

export default generateApiAction({
  baseType: Types.LOCATIONS.REORDER,
  api: reorderLocation,
  responseType: RESPONSETYPE.EMPTY
})



// WEBPACK FOOTER //
// ./src/actions/locations/ReorderAction.js